// @ts-strict-ignore
import { createContext } from 'react';
import type { KeyboardFocus } from '@usealloy/component-library';
import type { Action, ThresholdResults } from 'flow/store/engine/types';
import { ContainerType } from '../types';
import type { NodeTooltipProps } from 'flow/editor/components/Graph/nodes/BaseNode/NodeTooltip/NodeTooltip';
import { ruleBuilderEditMode } from './types';
import type { RuleBuilderEditMode } from './types';
import type { buildRuleTree, mapRulesToIndices, mapRuleToDepth } from 'flow/service/rules';
import type { RulesWithMLA } from 'flow/editor/components/mla/types';

type RuleBuilderContextType = {
  sourceAction: Action | null;
  containerType: ContainerType;
  editMode: RuleBuilderEditMode;
  keyboardFocus: KeyboardFocus;
  isPreviewOutcome: boolean;
  thresholdResults?: ThresholdResults;
  instanceId: string;
  ActionHoverTooltip?: (props: NodeTooltipProps) => JSX.Element;
  ruleTree: ReturnType<typeof buildRuleTree> | null;
  ruleIdToDepthMap: ReturnType<typeof mapRuleToDepth>;
  ruleIdToIndexMap: ReturnType<typeof mapRulesToIndices>;
  rulesWithMLA: RulesWithMLA;
  ruleTreeHasMultipleThresholds: boolean;
  isTreeAmbiguous: boolean;
};

export const RuleBuilderDefaultContext: RuleBuilderContextType = {
  sourceAction: null,
  containerType: ContainerType.DRAWER,
  editMode: ruleBuilderEditMode.editable,
  keyboardFocus: null,
  isPreviewOutcome: false,
  thresholdResults: null,
  instanceId: '',
  ActionHoverTooltip: undefined,
  ruleTree: null,
  ruleIdToDepthMap: {},
  ruleIdToIndexMap: {},
  rulesWithMLA: [],
  ruleTreeHasMultipleThresholds: false,
  isTreeAmbiguous: false,
};

export const RuleBuilderContext = createContext<RuleBuilderContextType>(RuleBuilderDefaultContext);
